<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
  v-else
  class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createInscripcionManual"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionMapEnrollmentsStudentsModalAdd.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section-height-auto">
        <p
          v-for="familia in familias"
          :key="familia.id"
          class="margin-bottom-large margin-top-large"
        >
          <label class="display-flex-row a-radiobutton-primary a-radiobutton-maps-primary width-100-pr">
            <input
              class="a-radiobutton-primary a-radiobutton-maps-primary"
              v-model="$modal.element.familia"
              name="familia"
              type="radio"
              :value="familia.id"
            >
            <span class="a-radiobutton-checkmark"></span>
            <span class="margin-left-xsmall">
              {{ familia.nombre }}
            </span>
          </label>
        </p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionMapEnrollmentsStudentsModalAdd.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapEnrollmentsFamiliesModalAdd',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsStudentsModalAdd.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },
      email: [],
      familias: [],
      familiaSelected: null,

      proyectoId: '',
      showLoadingState: true
    }
  },

  computed: {

  },

  watch: {

  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.email.push(this.$modal.element.email)
    this.proyectoId = this.$route.params.id
    this.readFamiliaNombres()
  },

  methods: {

    createInscripcionManual () {
      if (this.$modal.element.familia !== undefined && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('inscripcion', 'createInscripcionManual', { proyecto: this.proyectoId,
          familia: this.$modal.element.familia,
          email: this.email
        },
        [this.academiaId])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudentsModalAdd', 'createInscripcion', 'success')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionMapEnrollmentsStudentsModalAdd', 'createInscripcion', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      } else {
        this.$alerts.pushAlert('mEditionMapEnrollmentsStudentsModalAdd', 'createInscripcion', 'required', 'a-alert-danger')
      }
    },

    readFamiliaNombres () {
      this.$services.read('familia', 'readFamiliaNombres', {}, [this.proyectoId])
        .then(response => {
          this.familias = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
